export default "__VITE_ASSET__Dbj3UGsW__"